export class AnimationFrameRate {
  private fpsInterval: number;
  private now: number;
  private then: number;
  private elapsed: number;
  private app: PIXI.Application;
  private stop: boolean;

  constructor(app: PIXI.Application) {
    this.app = app;
    this.now = 0;
    this.then = 0;
    this.fpsInterval = 0;
    this.elapsed = 0;
    this.stop = false;
  }

  public startAnimating = (fps: number): void => {
    //  console.log(this.fpsInterval)
    this.fpsInterval = 1000 / fps;
    this.then = Date.now();
    this.animate();
    // console.log(this)
  };

  private animate = (): void => {
    // stop
    // console.log(this)
    if (this.stop) {
      return;
    }

    // request another frame
    // let self=this;
    requestAnimationFrame(this.animate);

    // calc elapsed time since last loop

    this.now = Date.now();
    this.elapsed = this.now - this.then;
    // if enough time has elapsed, draw the next frame

    if (this.elapsed > this.fpsInterval) {
      // Get ready for next frame by setting then=now, but...
      // Also, adjust for fpsInterval not being multiple of 16.67
      this.then = this.now - (this.elapsed % this.fpsInterval);

      // draw stuff here
      this.app.ticker.stop();
      this.app.ticker.update();
      PIXI.tweenManager.update(this.elapsed);
    }
    this.app.ticker.stop();
  };
}
